import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { DatePicker } from 'redux-form-material-ui';
import styles from '../../../shared-styles';

const BirthdayField = props => (
  <Field
    name="birthday"
    className={ props.className }
    component={ DatePicker }
    format={ null }
    floatingLabelText="Birthday *"
    hintText="Birthday"
    fullWidth={ true }
    autoComplete=""
    autoCapitalize="off"
    autoCorrect="off"
    validate={ props.validate }
    onChange={ props.onChange }
    maxDate={ new Date() }
    openToYearSelection={ true }
    dialogContainerStyle={ styles.datePicker }
  />
);

BirthdayField.propTypes = {
  validate: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default BirthdayField;
